import type { DeviceTrip, FullTrackingGraphQL, NewRoute } from '@cobliteam/api-lib';
import type { ESN, Media, StartEndDateRange, TimeIntervalInMillis, TimestampInMillis, UUID } from '@cobliteam/common-types';
import type * as Actions from './actions';
import { ActionTypes as Types } from './actionTypes';

export const loadRouteInfoSucceeded = (routeInfo: DeviceTrip): Actions.LoadRouteInfoSucceeded => ({
  type: Types.LOAD_ROUTE_INFO_SUCCEEDED,
  payload: routeInfo,
});

export const loadRouteInfoFailed = (): Actions.LoadRouteInfoFailed => ({
  type: Types.LOAD_ROUTE_INFO_FAILED,
});

export const loadRouteInfoRequest = (deviceId: ESN, vehicleId: UUID, date: TimestampInMillis, mediaEventsEnabled?: boolean): Actions.LoadRouteInfoRequest => ({
  type: Types.LOAD_ROUTE_INFO_REQUEST,
  payload: { deviceId, vehicleId, date, mediaEventsEnabled },
});

export const loadTrackingSucceeded = (trackingGraphQL: FullTrackingGraphQL): Actions.LoadTrackingSucceeded => ({
  type: Types.LOAD_TRACKING_SUCCEEDED,
  payload: trackingGraphQL,
});

export const loadTrackingFailed = (): Actions.LoadTrackingFailed => ({
  type: Types.LOAD_TRACKING_FAILED,
});

export const loadTrackingRequest = (vehicleId: UUID, startTimestamp: TimestampInMillis, endTimestamp: TimestampInMillis, useMapMatch: boolean): Actions.LoadTrackingRequest => ({
  type: Types.LOAD_TRACKING_REQUEST,
  payload: { vehicleId, startTimestamp, endTimestamp, useMapMatch },
});

export const setTrackingParameters = (
  vehicleId: UUID,
  startTimestamp: TimestampInMillis,
  endTimestamp: TimestampInMillis,
  useMapMatch: boolean
): Actions.SetTrackingParameters => ({
  type: Types.SET_TRACKING_PARAMETERS,
  payload: { vehicleId, startTimestamp, endTimestamp, useMapMatch },
});

export const updateTripFilterInterval = (period: StartEndDateRange | null): Actions.UpdateTripFilterInterval => ({
  type: Types.UPDATE_TRIP_FILTER_INTERVAL,
  payload: period,
});

export const loadSavedRoutesSucceeded = (routes: NewRoute[]): Actions.LoadSavedRoutesSucceeded => ({
  type: Types.LOAD_SAVED_ROUTES_SUCCEEDED,
  payload: routes,
});

export const loadSavedRoutesFailed = (): Actions.LoadSavedRoutesFailed => ({
  type: Types.LOAD_SAVED_ROUTES_FAILED,
});

export const loadSavedRoutesRequest = (date: TimeIntervalInMillis, vehicleId?: UUID): Actions.LoadSavedRoutesRequest => ({
  type: Types.LOAD_SAVED_ROUTES_REQUEST,
  payload: { date, vehicleId },
});

export const changedPlannedRoute = (route?: NewRoute): Actions.ChangedPlannedRoute => ({
  type: Types.CHANGED_PLANNED_ROUTE,
  payload: route,
});

export const loadMediaEventsRequest = (start: TimestampInMillis, end: TimestampInMillis, deviceId: ESN): Actions.LoadMediaEventsRequest => ({
  type: Types.LOAD_MEDIA_EVENTS_REQUEST,
  payload: {
    deviceId,
    startInMillis: start,
    endInMillis: end,
  },
});

export const loadMediaEventsSucceeded = (payload: Media[]): Actions.LoadMediaEventsSucceeded => ({
  type: Types.LOAD_MEDIA_EVENTS_SUCCEEDED,
  payload,
});

export const loadMediaEventsFailed = (): Actions.LoadMediaEventsFailed => ({
  type: Types.LOAD_MEDIA_EVENTS_FAILED,
});

export const showTab = (): Actions.ShowTab => ({
  type: Types.SHOW_TRACKING_TAB,
});

export const hideTab = (): Actions.HideTab => ({
  type: Types.HIDE_TRACKING_TAB,
});

export const setSelectedDeviceId = (deviceId?: ESN): Actions.SetSelectedDeviceId => ({
  type: Types.SET_SELECTED_DEVICE_ID,
  payload: deviceId,
});

export const setSelectedTrigger = (trigger?: any): Actions.SetSelectedTrigger => ({
  type: Types.SET_SELECTED_TRIGGER,
  payload: trigger,
});

export const setSelectedGeofenceId = (geofenceId?: UUID): Actions.SetSelectedGeofenceId => ({
  type: Types.SET_SELECTED_GEOFENCE_ID,
  payload: geofenceId,
});
